import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "ccm_theme";
const apply = (t) => document.documentElement.classList.toggle("light", t === "light");
apply(localStorage.getItem(KEY) || "dark");

export function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem(KEY) || "dark");
  useEffect(() => {
    const on = () => setTheme(localStorage.getItem(KEY) || "dark");
    window.addEventListener("ccm-theme", on);
    return () => window.removeEventListener("ccm-theme", on);
  }, []);
  const toggle = () => {
    const next = theme === "light" ? "dark" : "light";
    localStorage.setItem(KEY, next);
    apply(next);
    window.dispatchEvent(new Event("ccm-theme"));
  };
  return { theme, toggle };
}

export function ThemeToggle({ testId = "theme-toggle" }) {
  const { theme, toggle } = useTheme();
  const light = theme === "light";
  return (
    <button onClick={toggle} data-testid={testId} title={light ? "Switch to dark theme" : "Switch to light theme"} aria-label="Toggle theme"
      className="p-2 rounded-md text-slate-400 hover:text-[#F58B23] hover:bg-slate-800/60 transition-colors">
      {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
}
